module.exports = __webpack_public_path__ + "img/system_no_nfc.2c071ae7.png";